import {LOBBIES} from '../content/lobbies';
import {OUTLETS} from '../content/parties';
import {DI,DM,on} from '../content/settings';
import {budgetProj,debtLimit} from './budget';
import {applyEff} from './economy';
import {toast} from './govern';
import {press} from './media';
import {rnd} from './rng';
import {S,log} from './state';
import {clamp} from './util';


export function lobbyReact(fx?:any,mult=1){
  if(!on('lobby')||!fx)return;const d=lobbyDelta(fx,mult);
  for(const x in d)S.lob[x]=clamp(S.lob[x]+d[x],0,100);
}
export function lobbyDelta(fx?:any,mult=1){const g=fx.g||{},p=fx.pos||{},k=[.7,1,1.3][DI()]*mult;
  const d:any={gew:(g.arb||0)*1.2+(p.sozial||0)*2+(p.steuern||0)-(p.buero||0)*1.5,
   arbg:(g.unt||0)*1.2-(p.sozial||0)*1.2+(p.buero||0)*2-(p.steuern||0)*1.5,
   soz:((g.rent||0)+(g.fam||0))*.8+(p.sozial||0)*2.5+(p.wohnen||0),
   umw:(p.klima||0)*3+(p.verkehr||0)*1.5-(p.atom||0)*2};
  for(const x in d)d[x]=clamp(d[x],-15,15)*k;return d;
}
export function budgetReactLW(B?:any){const d=(k:any)=>(B.etat[k]||0)-((S.etat||{})[k]||0),dein=B.ein-(S.ein||0);
  if(on('lobby')){S.lob.soz=clamp(S.lob.soz+(d('as')+d('ge')+d('bf')+d('bw'))*.8,0,100);S.lob.umw=clamp(S.lob.umw+d('uk')*2+d('vk')*.5,0,100);S.lob.gew=clamp(S.lob.gew+d('as')*.5+d('vk')*.3,0,100);S.lob.arbg=clamp(S.lob.arbg-dein*.6+d('wi')+d('dg')*.5,0,100)}
  if(on('wings')){const soc=d('as')+d('ge')+d('bf')+d('bw');S.wing.soz=clamp(S.wing.soz+soc*.6+dein*.2,0,100);S.wing.wirt=clamp(S.wing.wirt-dein*.4-(budgetProj(B)<debtLimit()&&!B.not?6:0),0,100)}}
export function lobbyTick(){
  if(!on('lobby'))return false;let att=false;S.lobCD=S.lobCD||{};
  for(const k in LOBBIES){S.lob[k]+=(50-S.lob[k])*.015;const L=LOBBIES[k],v=S.lob[k];
    if((S.lobCD[k]||0)>S.m)continue;
    if(v<28&&rnd()<.06*DM()){applyEff(L.neg[1]);press(OUTLETS[0].n,L.neg[0],L.neg[2]);log(`${L.neg[0]}.`,'bad');toast(L.neg[0],'bad');S.lobCD[k]=S.m+6;att=true}
    else if(v>75&&rnd()<.04){applyEff(L.pos[1]);press(OUTLETS[1].n,L.pos[0],L.pos[2]);log(`${L.pos[0]}.`,'good');S.lobCD[k]=S.m+8}}
  return att;
}
export const lobbyBonus:any=()=>on('lobby')?clamp(Object.values<any>(S.lob).reduce((s:any,v:any)=>s+(v-50),0)/200*1.5,-1.5,1.5):0;
